import { Dictionary } from '../../../../../types/dictionary';

export interface EntityLocationParameters {
  id?: string | number;
  type?: 'bulk' | 'query' | 'template' | 'validation';
  queryParams?: Dictionary<unknown>;
  pathParams?: Dictionary<unknown>;
}
